import template from './template';
import styles from './template.css';
import {AoflElement, customElement, property} from '@aofl/element';
import {validationMixin, isRequired, isEqual, minLength} from '@aofl/form-validate';
import {isValidEmail, isNotEmoji, isNotEmail, isNotAllDigits} from '@aoflmkt/form-validators';
import {registerFormSdo} from './sdo';
import Cookies from 'js-cookie';
/**
 * @type {String}
 * @private
 */
const MIN_PWD_LENGTH = 5;

/**
 * @type {String}
 * @private
 */
const ELOG_COOKIE = 'elog_email';

/**
 * @summary RegisterForm
 * @extends {AoflElement}
 */
@customElement('register-form')
class RegisterForm extends validationMixin(AoflElement) {
  /**
   *
   * @readonly
   */
  static is = 'register-form';

  @property({type: String, attribute: false, store: registerFormSdo, mapState: 'email'})
  email = Cookies.get(ELOG_COOKIE);

  @property({type: String, attribute: false, store: registerFormSdo, mapState: 'confirmEmail'})
  confirmEmail = '';

  @property({type: String, attribute: false, store: registerFormSdo, mapState: 'password'})
  password = '';

  @property({type: String, attribute: false, store: registerFormSdo, mapState: 'confirmPassword'})
  confirmPassword = '';

  /**
   *
   * @return {Object}
   */
  defineValidators() {
    return {
      email: {isRequired, isValidEmail, isNotEmoji},
      confirmEmail: {isRequired, isEqual: isEqual('email')},
      password: {isRequired, minLength: minLength(MIN_PWD_LENGTH), isNotEmail, isNotAllDigits},
      confirmPassword: {isRequired, isEqual: isEqual('password')}
    };
  }

  /**
   *
   * @param {Object} e
   */
  submitForm(e) {
    e.preventDefault();
    this.dispatchEvent(new CustomEvent('registerFormSubmission'));
  }

  /**
   *
   * @param {Object} e
   */
  updateEmail(e) {
    registerFormSdo.email = e.target.value;
  }

  /**
   *
   */
  validateEmail() {
    this.form.email.validate();
  }

  /**
   *
   * @param {Object} e
   */
  updateConfirmEmail(e) {
    registerFormSdo.confirmEmail = e.target.value;
  }

  /**
   *
   */
  validateConfirmEmail() {
    this.form.confirmEmail.validate();
  }

  /**
   *
   * @param {Object} e
   */
  updatePassword(e) {
    registerFormSdo.password = e.target.value;
  }

  /**
   *
   */
  validatePassword() {
    this.form.password.validate();
  }


  /**
   *
   * @param {Object} e
   */
  updateConfirmPassword(e) {
    registerFormSdo.confirmPassword = e.target.value;
  }

  /**
   *
   */
  validateConfirmPassword() {
    this.form.confirmPassword.validate();
  }

  /**
   *
   */
  connectedCallback() {
    super.connectedCallback();
    this.validators = this.defineValidators();
  }

  /**
   * @param {Object} childTemplate - template to override default template
   * @param {Object} childStyles - styles for form
   * @return {Object}
   */
  render(childTemplate = template, childStyles = styles) {
    return super.render(childTemplate, ...childStyles);
  }

  /**
   *
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    registerFormSdo.reset();
  }
}

export {RegisterForm};
